export default "__VITE_ASSET__59046b9b__"